import { createSlice } from '@reduxjs/toolkit';

export const LANGUAGE_KEY = 'app_language';

export const getStoredLanguage = () => {
	return localStorage.getItem(LANGUAGE_KEY) || 'en';
};

export const setStoredLanguage = (lang) => {
	localStorage.setItem(LANGUAGE_KEY, lang);
};

const initialLanguage = getStoredLanguage();

export const languageSlice = createSlice({
	name: 'languages',
	initialState: { value: initialLanguage },
	reducers: {
		changeLanguage: (state, action) => {
			state.value = action.payload;
			setStoredLanguage(action.payload);
		},
	},
});
export const { changeLanguage } = languageSlice.actions;
export default languageSlice.reducer;
